import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import { facturaCostsService } from "~/services/facturaCostsService";

export type CreditNoteCost = { unitCost: number; costTotal: number };

/**
 * Fetches the per-line WAC return cost for credit-note (devolución) lines, so the
 * Facturas report can net credit-note cost out of "Costo de Ventas" the exact same
 * way the "Excel detallado" export does. Returns a Map keyed by
 * `${bsale_number}|${cod_prod}|${bsale_detail_id}`. Price-difference (administrative)
 * NCs have no return movement and are simply absent from the map.
 */
export function useCreditNoteCosts(bsaleNumbers: string[]) {
  const nums = useMemo(
    () => Array.from(new Set(bsaleNumbers.filter(Boolean))).sort(),
    [bsaleNumbers]
  );

  return useQuery<Map<string, CreditNoteCost>>({
    queryKey: ["credit-note-costs", nums],
    queryFn: () => facturaCostsService.getCreditNoteLineCosts(nums),
    enabled: nums.length > 0,
    staleTime: 5 * 60 * 1000,
  });
}
